module.exports = __webpack_public_path__ + "static/media/3-seo-new.bb2cad5e.png";